import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'sonner';
import api from '../../config/axions.config';
import Swal from 'sweetalert2';

const AddRoles = () => {
  let navigate = useNavigate();

  const date = new Date();
  const [type, setType] = useState('');
  const [roleTypeActive, setRoleTypeActive] = useState(true)
  const [permissions, setPermissions] = useState({
    student: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    enrollment: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    master: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    system: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    expense: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
  })

  async function addRole(e) {
    e.preventDefault(); // Prevent page reload
    Swal.fire({
      title: "Create New Role?",
      text: "Do you want to Create new Role",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create."
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!type) {
          toast.error("Some fields are empty");
          return;
        }
        try {
          let responce = await api.post('userRole', { type, is_active: roleTypeActive, permissions });
          if (responce.data.status) {
            toast.success(responce.data.message);
            setType('');
            setRoleTypeActive(true);
          }
          else {
            toast.error(responce.data.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
          let list = error.response.data.errors || [];
          for (let item of list) {
            toast.warning(item.msg)
          }
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }

  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <nav className="sm:hidden" aria-label="Back">
          <div className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
            <svg className="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-</div>1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            Back
          </div>
        </nav>

        <nav className="hidden sm:flex" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-4">
            <li>
              <div>
                <div className="text-gray-400 hover:text-gray-500">
                  <svg className="flex-shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                  </svg>
                  <span className="sr-only">Home</span>
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-4 text-sm text-gray-500 hover:text-gray-700" onClick={() => navigate('/dashboard/role/')}>
                  Role Type
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-3 text-sm text-gray-500 hover:text-gray-700" aria-current="page">
                  Add Role
                </div>
              </div>
            </li>
          </ol>
        </nav>

        <hr className="my-5 border-gray-300" />

        <div className="lg:flex lg:items-center lg:space-x-8">
          <div className="lg:flex-1 lg:min-w-0">
            <h1 className="text-2xl font-semibold text-primary-600">
              Role Type
            </h1>
            <div className="mt-2 md:mt-3 sm:flex sm:items-center sm:space-x-6">
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                </svg>
                <span className="text-gray-600">
                  Type Id
                </span>
              </div>

              <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                  <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                </svg>
                <span className="text-gray-600">
                  Started - {date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center mt-5 ml-auto space-x-6 lg:justify-end lg:mt-0 lg:flex-shrink-0">
            <div className="flex items-center space-x-2">
              <label htmlFor="">
                Role Status
              </label>
              <div className="toggle-switch">
                <input type="checkbox" checked={roleTypeActive} onChange={() => setRoleTypeActive(!roleTypeActive)} id="toggleSwitch" value={true} />
                <label htmlFor="toggleSwitch"></label>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-6">
          <div className="bg-white rounded-lg shadow">
            <div className="px-4 py-3 sm:px-6">
              <div className="flex items-center -ml-2">
                <div title="Back" className="btn-circle" aria-label="Back" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/role/')}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                  </svg>
                </div>

                <h2 className="ml-2 text-lg font-medium leading-6 text-gray-900">
                  Add New Role
                </h2>
              </div>
            </div>

            <div className="px-4 py-5 border-t border-gray-300 sm:px-6">
              <form onSubmit={(e) => addRole(e)}>
                <div className="space-y-4">
                  <div>
                    <label htmlFor="">
                      Role Type <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <input type="text" value={type} onChange={(e) => setType(e.target.value)} placeholder="Enter Type Name" className="" />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="">
                      Role Permission
                    </label>
                  </div>

                  <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                          <table className="custom-table">
                            <thead>
                              <tr>
                                <th scope="col">
                                  Category
                                </th>
                                <th scope="col" className="hidden lg:table-cell">
                                  Add
                                </th>
                                <th scope="col" className="hidden lg:table-cell">
                                  View
                                </th>
                                <th scope="col" className="hidden lg:table-cell">
                                  Edit
                                </th>
                                <th scope="col" className="hidden lg:table-cell">
                                  Delete
                                </th>
                                <th scope="col" className="hidden lg:table-cell">
                                  Select All
                                </th>
                              </tr>
                            </thead>
                            {/* table body */}
                            <tbody>
                              {/* student */}
                              <tr>
                                <td>
                                  <div className="flex items-center">
                                    <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                      <span className="font-medium leading-none text-white">IN</span>
                                    </div>
                                    <div className="flex-1 min-w-0 ml-2">
                                      <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                        Students
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {/* create */}
                                <td className="hidden lg:table-cell whitespace-nowrap">
                                  <input
                                    type="checkbox"
                                    checked={permissions.student.create}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        student: {
                                          ...prev.student,
                                          create: !prev.student.create,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* read  */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.student.read}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        student: {
                                          ...prev.student,
                                          read: !prev.student.read,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* Edit / Update */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.student.update}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        student: {
                                          ...prev.student,
                                          update: !prev.student.update,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* delete / Deletef */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.student.delete}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        student: {
                                          ...prev.student,
                                          delete: !prev.student.delete,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* selecte all */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={
                                      permissions.student.create &&
                                      permissions.student.read &&
                                      permissions.student.update &&
                                      permissions.student.delete
                                    }
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        student: {
                                          create: !(
                                            permissions.student.create &&
                                            permissions.student.read &&
                                            permissions.student.update &&
                                            permissions.student.delete
                                          ),
                                          read: !(
                                            permissions.student.create &&
                                            permissions.student.read &&
                                            permissions.student.update &&
                                            permissions.student.delete
                                          ),
                                          update: !(
                                            permissions.student.create &&
                                            permissions.student.read &&
                                            permissions.student.update &&
                                            permissions.student.delete
                                          ),
                                          delete: !(
                                            permissions.student.create &&
                                            permissions.student.read &&
                                            permissions.student.update &&
                                            permissions.student.delete
                                          ),
                                        },
                                      }))
                                    }
                                  />
                                </td>
                              </tr>
                              {/* Enrollment */}
                              <tr>
                                <td>
                                  <div className="flex items-center">
                                    <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                      <span className="font-medium leading-none text-white">IN</span>
                                    </div>
                                    <div className="flex-1 min-w-0 ml-2">
                                      <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                        Enrollments
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {/* create */}
                                <td className="hidden lg:table-cell whitespace-nowrap">
                                  <input
                                    type="checkbox"
                                    checked={permissions.enrollment.create}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        enrollment: {
                                          ...prev.enrollment,
                                          create: !prev.enrollment.create,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* read  */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.enrollment.read}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        enrollment: {
                                          ...prev.enrollment,
                                          read: !prev.enrollment.read,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* Edit / Update */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.enrollment.update}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        enrollment: {
                                          ...prev.enrollment,
                                          update: !prev.enrollment.update,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* delete / Deletef */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.enrollment.delete}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        enrollment: {
                                          ...prev.enrollment,
                                          delete: !prev.enrollment.delete,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* selecte all */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={
                                      permissions.enrollment.create &&
                                      permissions.enrollment.read &&
                                      permissions.enrollment.update &&
                                      permissions.enrollment.delete
                                    }
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        enrollment: {
                                          create: !(
                                            permissions.enrollment.create &&
                                            permissions.enrollment.read &&
                                            permissions.enrollment.update &&
                                            permissions.enrollment.delete
                                          ),
                                          read: !(
                                            permissions.enrollment.create &&
                                            permissions.enrollment.read &&
                                            permissions.enrollment.update &&
                                            permissions.enrollment.delete
                                          ),
                                          update: !(
                                            permissions.enrollment.create &&
                                            permissions.enrollment.read &&
                                            permissions.enrollment.update &&
                                            permissions.enrollment.delete
                                          ),
                                          delete: !(
                                            permissions.enrollment.create &&
                                            permissions.enrollment.read &&
                                            permissions.enrollment.update &&
                                            permissions.enrollment.delete
                                          ),
                                        },
                                      }))
                                    }
                                  />
                                </td>
                              </tr>
                              {/* MASTER */}
                              <tr>
                                <td>
                                  <div className="flex items-center">
                                    <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                      <span className="font-medium leading-none text-white">IN</span>
                                    </div>
                                    <div className="flex-1 min-w-0 ml-2">
                                      <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                        Master
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {/* create */}
                                <td className="hidden lg:table-cell whitespace-nowrap">
                                  <input
                                    type="checkbox"
                                    checked={permissions.master.create}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        master: {
                                          ...prev.master,
                                          create: !prev.master.create,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* read  */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.master.read}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        master: {
                                          ...prev.master,
                                          read: !prev.master.read,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* Edit / Update */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.master.update}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        master: {
                                          ...prev.master,
                                          update: !prev.master.update,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* delete / Deletef */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.master.delete}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        master: {
                                          ...prev.master,
                                          delete: !prev.master.delete,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* selecte all */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={
                                      permissions.master.create &&
                                      permissions.master.read &&
                                      permissions.master.update &&
                                      permissions.master.delete
                                    }
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        master: {
                                          create: !(
                                            permissions.master.create &&
                                            permissions.master.read &&
                                            permissions.master.update &&
                                            permissions.master.delete
                                          ),
                                          read: !(
                                            permissions.master.create &&
                                            permissions.master.read &&
                                            permissions.master.update &&
                                            permissions.master.delete
                                          ),
                                          update: !(
                                            permissions.master.create &&
                                            permissions.master.read &&
                                            permissions.master.update &&
                                            permissions.master.delete
                                          ),
                                          delete: !(
                                            permissions.master.create &&
                                            permissions.master.read &&
                                            permissions.master.update &&
                                            permissions.master.delete
                                          ),
                                        },
                                      }))
                                    }
                                  />
                                </td>
                              </tr>
                              {/* System */}
                              <tr>
                                <td>
                                  <div className="flex items-center">
                                    <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                      <span className="font-medium leading-none text-white">IN</span>
                                    </div>
                                    <div className="flex-1 min-w-0 ml-2">
                                      <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                        System
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {/* create */}
                                <td className="hidden lg:table-cell whitespace-nowrap">
                                  <input
                                    type="checkbox"
                                    checked={permissions.system.create}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        system: {
                                          ...prev.system,
                                          create: !prev.system.create,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* read  */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.system.read}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        system: {
                                          ...prev.system,
                                          read: !prev.system.read,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* Edit / Update */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.system.update}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        system: {
                                          ...prev.system,
                                          update: !prev.system.update,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* delete / Deletef */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.system.delete}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        system: {
                                          ...prev.system,
                                          delete: !prev.system.delete,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* selecte all */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={
                                      permissions.system.create &&
                                      permissions.system.read &&
                                      permissions.system.update &&
                                      permissions.system.delete
                                    }
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        system: {
                                          create: !(
                                            permissions.system.create &&
                                            permissions.system.read &&
                                            permissions.system.update &&
                                            permissions.system.delete
                                          ),
                                          read: !(
                                            permissions.system.create &&
                                            permissions.system.read &&
                                            permissions.system.update &&
                                            permissions.system.delete
                                          ),
                                          update: !(
                                            permissions.system.create &&
                                            permissions.system.read &&
                                            permissions.system.update &&
                                            permissions.system.delete
                                          ),
                                          delete: !(
                                            permissions.system.create &&
                                            permissions.system.read &&
                                            permissions.system.update &&
                                            permissions.system.delete
                                          ),
                                        },
                                      }))
                                    }
                                  />
                                </td>
                              </tr>
                              {/* Expenses */}
                              <tr>
                                <td>
                                  <div className="flex items-center">
                                    <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                      <span className="font-medium leading-none text-white">IN</span>
                                    </div>
                                    <div className="flex-1 min-w-0 ml-2">
                                      <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                        expensess
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {/* create */}
                                <td className="hidden lg:table-cell whitespace-nowrap">
                                  <input
                                    type="checkbox"
                                    checked={permissions.expense.create}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        expense: {
                                          ...prev.expense,
                                          create: !prev.expense.create,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* read  */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.expense.read}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        expense: {
                                          ...prev.expense,
                                          read: !prev.expense.read,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* Edit / Update */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.expense.update}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        expense: {
                                          ...prev.expense,
                                          update: !prev.expense.update,
                                        },
                                      }))
                                    }
                                    name=""
                                    id=""
                                  />
                                </td>
                                {/* delete / Deletef */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={permissions.expense.delete}
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        expense: {
                                          ...prev.expense,
                                          delete: !prev.expense.delete,
                                        },
                                      }))
                                    }
                                  />
                                </td>
                                {/* selecte all */}
                                <td className="hidden lg:table-cell">
                                  <input
                                    type="checkbox"
                                    checked={
                                      permissions.expense.create &&
                                      permissions.expense.read &&
                                      permissions.expense.update &&
                                      permissions.expense.delete
                                    }
                                    onChange={() =>
                                      setPermissions((prev) => ({
                                        ...prev,
                                        expense: {
                                          create: !(
                                            permissions.expense.create &&
                                            permissions.expense.read &&
                                            permissions.expense.update &&
                                            permissions.expense.delete
                                          ),
                                          read: !(
                                            permissions.expense.create &&
                                            permissions.expense.read &&
                                            permissions.expense.update &&
                                            permissions.expense.delete
                                          ),
                                          update: !(
                                            permissions.expense.create &&
                                            permissions.expense.read &&
                                            permissions.expense.update &&
                                            permissions.expense.delete
                                          ),
                                          delete: !(
                                            permissions.expense.create &&
                                            permissions.expense.read &&
                                            permissions.expense.update &&
                                            permissions.expense.delete
                                          ),
                                        },
                                      }))
                                    }
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-center space-x-4 sm:justify-end" onClick={() => navigate('/dashboard/role/')}>
                    <button type="button" className="w-full btn btn-light sm:w-auto" >
                      Back
                    </button>

                    <button type="submit" className="w-full btn btn-primary sm:w-auto">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div >
      </div >
    </div >
  )
}

export default AddRoles
